<template>

	<card>
		<template slot="header">
		
			<div class="row align-items-center">
				<div class="col-12 col-md-8">
					<h6>Aggiunte contrattuali e/o altro</h6>
				</div>
				<div class="col-12 col-md-4 text-center text-md-right">
					<base-button
						type="primary"
						@click="addLine()">
						<i class="tim-icons icon-simple-add"></i>
						Aggiungi riga
					</base-button>
				</div>
			</div>
		</template>
		<div
			class="row"
			v-for="(additionalLine, $index) in model.workedDetails.additionalLines"
			:key="$index">
			<div class="col-12 col-md-4 col-lg-3">
				<base-input
					@input="checkInput"
					label="Dicitura"
					v-model="additionalLine.label"
					:name="`${$index}contractualPriceDescription`"
					input-size="form-control-lg"
					placeholder="Inserisci dicitura contrattuale" />
			</div>
			<div class="col-12 col-md-4 col-lg-3">
				<base-input
					@input="checkInput"
					label="Ammontare (€)"
					v-model="additionalLine.amount"
					:name="`${$index}contractualPrice`"
					type="number"
					step="0.01"
					input-size="form-control-lg"
					placeholder="Inserisci prezzo" />
			</div>
		</div>
	</card>
</template>
<script>
	import { debounce } from "debounce"

	export default {
		name : 'revision-woked-additional-lines',
		props: {
			model: Object,
		},
		methods: {
			addLine() {
				this.model.workedDetails.additionalLines.push({})
			},
			checkInput: debounce(function({target}){
				const lastAdditionalLine = this.model.workedDetails.additionalLines[this.model.workedDetails.additionalLines.length - 1]
				// const lastDescription = this.model.productsUsed[this.model.productsUsed.length-1].description;
				// const lastCode = this.model.productsUsed[this.model.productsUsed.length-1].description;
				//Se qualcosa è valorizzao
				if (lastAdditionalLine !== undefined
					&& ( lastAdditionalLine.label
						|| lastAdditionalLine.value
					)){
					this.addLine()
				}
				// // rimuovo gli ultimi
				const vm = this;
				this.model.workedDetails.additionalLines = this.model
					.workedDetails.additionalLines
					.filter((line,i) => {
						return i === vm.model.workedDetails.additionalLines.length - 1 
							|| (line.label
							|| line.value)
					})
			},500),
		}
	}
</script>